import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import { useAppSelector } from 'Store';
import { useRecuperarRelogiosDePontoQuery } from 'View/Service/Default/RelogiosDePonto';

const Pontos = (): React.ReactElement => {
  const navegacao = useNavigate();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const { data: { relogios_de_ponto } = {} } = useRecuperarRelogiosDePontoQuery(
    {
      options: { usuario_id: usuario?.id, assinado: 0 },
    }
  );

  return (
    <React.Fragment>
      {relogios_de_ponto?.length ? (
        <div
          className="alert alert-danger cursor-pointer"
          onClick={() => navegacao('/relogios-de-ponto/historico')}
        >
          <strong className="me-3">
            <Icone nome="exclamation-circle-fill" /> Atenção
          </strong>
          Existem arquivos do <strong>relógio de ponto</strong> para você
          assinar!
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Pontos;
